import { Button } from '@/components/shadcn/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/shadcn/dropdown-menu'
import { ConfirmDialog } from '@/components/ui/ConfirmDialog'
import { useRestClient } from '@/contexts/QueryProvider'
import { IconDeleteOutline } from '@icons/IconDeleteOutline'
import { IconEditOutline } from '@icons/IconEditOutline'
import { IconMenuOutline } from '@icons/IconMenuOutline'
import { toast } from 'sonner'
import AddCollaborationChannelFormV2, { CollaborationChannel } from '../../Forms/AddCollaborationChannelFormV2'
import { useCurrentApplication } from '../../useCurrentApplication'

export function ChannelCardActionsMenu({ channel, onUpdate }: { channel: CollaborationChannel; onUpdate: () => void }) {
  const { applicationId } = useCurrentApplication()

  const { deleteCollaborationApiDeleteCollaborationChannel } = useRestClient()

  const { mutate: deleteChannel } = deleteCollaborationApiDeleteCollaborationChannel.useMutation()

  const handleChannelDelete = () => {
    if (!channel.id) {
      toast.error('Cannot delete: missing channel id')
      return
    }
    deleteChannel({
      path: {
        applicationId,
        channelId: channel.id,
      },
    })
    onUpdate()
  }

  return (
    <DropdownMenu
      onOpenChange={(open) => {
        // This is necessary to maintain the open state when we want to keep it open
        if (!open) {
          // Check if we need to prevent closing
          // This is a placeholder for custom logic you might need
          // We'll use other mechanisms to prevent closing on item click
        }
      }}
    >
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="icon" className="size-8 justify-self-end">
          <IconMenuOutline size={16} />
          <span className="sr-only">Open menu</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        onCloseAutoFocus={(e) => {
          // Prevent focus returning to trigger which can close the menu
          e.preventDefault()
        }}
      >
        <DropdownMenuLabel>Actions</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <AddCollaborationChannelFormV2
          selectedChannel={channel}
          sheetTitle="Edit Collaboration Channel"
          sheetDescription="Edit the collaboration channel"
          sheetTrigger={
            <DropdownMenuItem onSelect={(e) => e.preventDefault()}>
              <div className="flex items-center gap-2">
                <IconEditOutline size={16} />
                <span>Edit collaboration channel</span>
              </div>
            </DropdownMenuItem>
          }
        />
        <ConfirmDialog
          title="Confirm Delete"
          description="Are you sure you want to delete this collaboration channel?"
          onConfirm={handleChannelDelete}
          trigger={
            <DropdownMenuItem onSelect={(e) => e.preventDefault()}>
              <div className="flex items-center gap-2">
                <IconDeleteOutline size={16} />
                <span>Delete collaboration channel</span>
              </div>
            </DropdownMenuItem>
          }
        />
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
